const IssuePriorityLabels = {
	0: 'Low',
	1: 'Medium',
	2: 'High',
	3: 'Max',
}

export default IssuePriorityLabels